import cn from '@sindresorhus/class-names';
import React, {
  ButtonHTMLAttributes,
  DetailedHTMLProps,
  forwardRef,
} from 'react';

import styles from './IconButton.module.scss';

type Props = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

const IconButtonComponent = forwardRef<HTMLButtonElement, Props>(
  ({children, className, ...rest}, ref) => {
    return (
      <button
        type="button"
        className={cn(styles.root, className)}
        ref={ref}
        {...rest}
      >
        <span className={styles.icon}>{children}</span>
      </button>
    );
  },
);

IconButtonComponent.displayName = 'IconButton';

export const IconButton = IconButtonComponent;
